import { render } from "./SummaryCard.vue?vue&type=template&id=4b9ff54e&scoped=true"
import script from "./SummaryCard.vue?vue&type=script&lang=js"
export * from "./SummaryCard.vue?vue&type=script&lang=js"

import "./SummaryCard.vue?vue&type=style&index=0&id=4b9ff54e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b9ff54e"]])

export default __exports__